var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedininline = function SvgLinkedininline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.356 18V7.419H2.1V18zm0-14.332C5.336 2.72 4.71 2 3.688 2 2.668 2 2 2.721 2 3.668c0 .926.648 1.668 1.649 1.668h.02c1.04 0 1.687-.742 1.687-1.668M10.668 18v-6.029c0-.322.023-.645.118-.875.258-.645.846-1.313 1.833-1.313 1.292 0 2.103.737 2.103 2.188V18H18v-6.19c0-3.316-1.762-4.86-4.113-4.86-1.927 0-2.773 1.083-3.243 1.82l.024-1.415H7.396c.047 1.013 0 10.645 0 10.645z"
  })));
};
export default SvgLinkedininline;